import { useTranslate, useRecordContext } from 'react-admin'
import {useState, useEffect} from 'react'
import { itemServices } from 'src/services/reservation/item/item.service'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_LIST } from 'src/helper/Permission'
import {Box} from '@mui/material'
import { LoadingButton } from '@mui/lab'

export const EditOriginValues = ({setOpenPricingModal, isBillable, setEnableReliquidation}) =>{
  const record = useRecordContext()
  const translate = useTranslate()
  const [billingStatus, setBillingStatus] = useState()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(()=>{
    itemServices.get_billing_status(record.hash_).then((res)=>{
      setBillingStatus(res.billable_status)
    }).finally(()=>{
        setIsLoading(false)
    })
  },[])

  const disableLogic = () =>{
    const isDisable = ((billingStatus === 'BILLED' && !hasPermissionFunction('pricing', 'edit_billed') &&
      //provisional check of billing module
      hasPermissionFunction('sales', PERMISSION_LIST)) || isBillable)
    setEnableReliquidation(!isDisable)
    return isDisable
  }
  
  return(
    <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
      <HasPermission permission='hasEdit' resource={'pricing'}>
        <LoadingButton
          onClick={() => {
            setOpenPricingModal(true)
          }}
          loading={isLoading}
          sx={{ paddingX: '10px', marginX:'5px' }}
          size='small'
          variant='contained'
          disabled={disableLogic()}
        >
          {translate('ra.title.update_pricing')}
        </LoadingButton>
      </HasPermission>
    </Box>
  )
}